module.exports = __webpack_public_path__ + "static/media/sd.60954d29.svg";